// import angular from 'angular';

export function GiveFocusDirective () : ng.IDirective {
  return {
    require : 'ngModel',
    restrict: 'A',
    link ( scope : ng.IScope, element : JQLite ) {
      setTimeout(() =>{
        element[0].focus({
          preventScroll: true
        });
      });
    },
  };
}
